import React from "react"
import { ListBox } from "../../../lib/fragments/ListBox"
import { ListboxButton, ListboxOption } from "@headlessui/react"
import { displayStylesArray } from "../../../utils/Constants"
import { ToggleSwitch } from "../../../components/utils/ToggleSwitch"

export const PredefinedRestriction = ({ state, setstate, listboxHandler, blurHandler, changeHandler }) => {
    const toogleSwitchHandler = (e: any) => {
        let { input, posting } = state
        if (posting) return

        switch (e.target.name) {
            case 'allow_mulitple':
                if (input.display_style?.key !== 'dropdown') return
                break;

            default:
                break;
        }

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                [e.target.name]: e.target.checked
            }
        }))
    }

    return (
        <React.Fragment>
            <div className="w-full pb-4">
                 <p className="text-sm text-slate-800 dark:text-slate-200 truncate pb-1 uppercase">
                    Display Style
                </p>

                <span className="block text-sm text-slate-500 dark:text-slate-400 py-1 pb-3">
                    Specify the input's visual style and interaction type
                </span>

                <div className="pt-2 px-1 w-full md:max-w-[300px]">
                    <ListBox
                        value={state.input.display_style ? state.input.display_style?.key : ''}
                        eventHandler={(e: any) => listboxHandler(e, 'display_style')}
                        button={
                            <ListboxButton className="relative border w-full rounded-md py-2 pr-2 text-left cursor-default focus:ring-primary focus:border-primary sm:text-sm ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border-slate-300 dark:border-slate-600 dark:text-white">
                                <div className="flex w-full items-center align-middle">
                                    <div className="flex-grow flex items-center">
                                        <span className="truncate ml-3 font-normal group-data-[selected]:font-semibold">
                                            <div className="flex items-center gap-x-4">
                                                <span className="truncate group-data-[selected]:font-semibold">
                                                    {state.input.display_style?.label}
                                                </span>
                                            </div>
                                        </span>
                                    </div>

                                    <span className="fa-light fa-chevron-down focus:text-primary float-end"></span>
                                </div>
                            </ListboxButton>
                        }
                        options={
                            <>
                                {
                                    displayStylesArray.map((displayStyle: any) => (
                                        <ListboxOption key={`attr-display-style-${displayStyle.key}`} value={displayStyle} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-orange-100 dark:data-[focus]:bg-orange-900/70 data-[focus]:text-orange-700 dark:data-[focus]:text-orange-500 rounded-md w-full">
                                            <div className="flex items-center gap-x-4">
                                                <span className="truncate group-data-[selecteßd]:font-medium">
                                                    {displayStyle.label}
                                                </span>
                                            </div>

                                            <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                <span className="fa-light fa-check"></span>
                                            </span>
                                        </ListboxOption>
                                    ))
                                }
                            </>
                        }
                    />
                </div>

                {
                    state.errors.display_style.length > 0 && (
                        <span className='invalid-feedback text-xs text-red-600 dark:text-red-400 pl-1 pt-1'>
                            {state.errors.display_style}
                        </span>
                    )
                }
            </div>

            <div className="w-full py-4">
                <ToggleSwitch
                    name={'allow_mulitple'}
                    label={'Allow Multiple'}
                    checked={state.input.allow_mulitple}
                    changeHandler={toogleSwitchHandler}
                    description={"Ideal for situations where more than one option is valid"}
                    disabled={state.input.display_style?.key === 'dropdown' ? false : true}
                />
            </div>


            <div className="w-full py-4 border-t border-slate-300 dark:border-slate-600">
                <ToggleSwitch
                    label={'Required?'}
                    name={'mandatory'}
                    checked={state.input.mandatory}
                    changeHandler={toogleSwitchHandler}
                    description={"Ensures a value is provided before submitting"}
                />
            </div>
        </React.Fragment>
    )
}